<template>
  <div class="verify">
      <h2>
          {{$t('accountVerify')}}
          {{active == 0?$t('verifyStep1'):(active == 1?$t('verifyStep2'):(active == 2?$t('verifyStep3'):(active == 3?$t('verifyStep4'):(active == 4 || active == 5?$t('verifyStep5'):''))))}}
      </h2>
      <div class="content_wrapper">
            <div class="activate-process">
                <div class="process-item" :class="active <= 0?'active':'finished'" >
                    <span>1</span><br>
                    <b>{{$t('verifyStep1')}}</b>
                </div>
                <div class="process-item left25" :class="active == 1?'active':(active > 1 ? 'finished':'')">
                    <span>2</span><br>
                    <b>{{$t('verifyStep2')}}</b>
                </div>
                <div class="process-item left50" :class="active == 2 ?'active':(active > 2 ? 'finished':'')">
                    <span>3</span><br>
                    <b>{{$t('verifyStep3')}}</b>
                </div>
                <div class="process-item left75" :class="active == 3 ?'active':(active > 3 ? 'finished':'')">
                    <span>4</span><br>
                    <b>{{$t('verifyStep4')}}</b>
                </div>
                <div class="process-item left100" :class="active == 4 || active == 5 ?'complete':''">
                    <span>5</span><br>
                    <b>{{$t('verifyStep5')}}</b>
                </div>
            </div>
            <basic-info v-if="active==0" @changeSteps="changeSteps" @saveSteps="saveSteps"></basic-info>
            <financial-info v-if="active==1" @changeSteps="changeSteps" @saveSteps="saveSteps"></financial-info>
            <knowledge-experience v-if="active==2" @changeSteps="changeSteps" @saveSteps="saveSteps"></knowledge-experience>
            <signature-declaration v-if="active==3" @changeSteps="changeSteps" @saveSteps="saveSteps"></signature-declaration>
            <complete-register v-if="active==4 || active == 5" @changeSteps="changeSteps" @saveSteps="saveSteps"></complete-register>

      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import BasicInfo from './BasicInfo.vue';
import FinancialInfo from './FinancialInfo.vue';
import KnowledgeExperience from './KnowledgeExperience.vue';
import SignatureDeclaration from './SignatureDeclaration.vue';
import CompleteRegister from './CompleteRegister.vue';


export default {
  name: 'Home',
  components: {
    BasicInfo,
    FinancialInfo,
    KnowledgeExperience,
    SignatureDeclaration,
    CompleteRegister
  },
  data(){
    return{
        loading:false,
        active:0,
    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
        // console.log(this.userInfo.questionProgress )
        // this.getRealList()
        this.active = this.userInfo.questionProgress 
    },
    methods:{
       
        openDialog(value){
            if(value == 'real'){
                // console.log(this.isOpenReal)
                this.isOpenReal = true
            }
        },
        changeSteps(val){
            // console.log(val)
            this.active = val
            window.scrollTo(0,0);
        },
        closeDialogLeverage(val){
            // console.log(val)
            this.isOpenLeverage = val
        },
        closeDialogReset(val){
            // console.log(val)
            this.isOpenReset = val
        },
        saveSteps(val){
            // console.log(1111111111)
            let userInfoCopy = this.userInfo
            userInfoCopy.questionProgress = val
            // console.log(userInfoCopy)
            this.$store.commit('setUserInfo', userInfoCopy)
          
        }
    }
}
</script>
<style lang="less">
.verify{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    .content_wrapper{
        background-color: #f9fafb;
        border: 1px solid #f0f0f0;
        padding-top: 100px;
        .activate-process{
            position: relative;
            width: 60%;
            height: 3px;
            margin: 0px auto 110px;
            text-align: center;
            background-color: #e5e5e5;
            .process-item{
                position: absolute;
                top: -18px;
                left: 0px;
                transform: translateX(-50%);
                color: #332c2b;
                white-space: nowrap;
                span{
                    display: inline-block;
                    width: 34px;
                    height: 34px;
                    margin-bottom: 22px;
                    line-height: 34px;
                    color: #332c2b;
                    font-size: 14px;
                    background-color: #f5f5f5;
                    border: 1px solid #e5e5e5;
                    border-radius: 50%;
                    font-family: 'Montserrat-Regular';
                    cursor: pointer;
                }
                b{
                    font-weight: normal;
                }
            }
            .left25{
                left: 25%;
            }
            .left50{
                left: 50%;
            }
            .left75{
                left: 75%;
            }
            .left100{
                left: 100%;
            }
            .active,
            .complete,
            .finished{
                top: -24px;
                span{
                    width: 48px;
                    height: 48px;
                    margin-bottom: 14px;
                    font-size: 18px;
                    line-height: 48px;
                    background-color: #e32b3a;
                    border-color: #e32b3a;
                    color: #fff;
                    
                }
            }
            .active::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 50%;
                width: 72px;
                height: 3px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            .finished::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 55%;
                width: 160px;
                height: 4px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            
        }
    }
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .ivu-form-item{
        width: 48%;
    }
    .inputForm{
        h3{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        h3::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        .item4{
            width: 24%;
        }
        .item3{
            width: 32%;
        }
    }
}
</style>
